import {
  Button,
  Container,
  Dialog,
  Divider,
  Grid,
  IconButton,
  Paper,
  Stack,
  Tab,
  Tabs,
  Typography,
  TextField as MuiTextField,
  Box
} from '@mui/material';
import { Checkbox, FormProvider, SelectTag, Table, TextField } from '../../../../../components';
import { useForm } from 'react-hook-form';
import SearchIcon from '@mui/icons-material/Search';
import CloseIcon from '@mui/icons-material/Close';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import {
  dateFormatter,
  dropdownFetch,
  getCityByState,
  getCurrentDateTime,
  getDateDifference,
  getISTDate,
  getKeyPathValue,
  getStatesByCountry,
  request,
  toast
} from '../../../../../utils';
import { useCallback, useEffect, useState } from 'react';
import {
  ADMISSION_TYPE,
  GENDER_DROPDOWN,
  MARITAL_STATUS,
  MLC,
  REFERRAL_TYPE,
  RELATION
} from '../../../../../constants';
import { IndoorRegisterationPDF } from './IndoorRegisterationPDF';
import { useLocation } from 'react-router-dom';
import { CustomButtonn } from '../../../../../components';
import axios from 'axios';
import { BASE_URL } from '../../../../../utils';

const TABLE_COLUMNS = [
  {
    header: 'UHID No.',
    accessor: 'uhid'
  },
  {
    header: 'Patient Name',
    accessor: (row) => {
      const status = row.status;
      return (
        <span
          style={{
            color: status === 'inactive' ? 'red' : 'black'
          }}
        >
          {`${row?.patient.name}`}
        </span>
      );
    }
  },
  {
    header: 'Addmission Date',
    accessor: (row) => `${getCurrentDateTime('date', row.date)}`
  },
  {
    header: 'IPD No.',
    accessor: 'ipd_no'
  },
  {
    header: 'Mobile No.',
    accessor: 'patient.mobile'
  },
  {
    header: 'Status',
    accessor: 'status',
    sx: { textTransform: 'uppercase' }
  }
];

function formatDate(dateString) {
  const date = new Date(dateString);

  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const year = date.getFullYear();

  return `${day}/${month}/${year}`;
}
const PATIENT_TABLE_HEADER = [
  { header: 'UHID', accessor: 'uhid' },
  { header: 'OP No', accessor: 'op_no' },
  { header: 'Created At', accessor: (row) => formatDate(row?.date) },
  { header: 'Patient Name', accessor: (row) => `${row?.name_suffix} ${row?.first_name} ${row?.last_name}` },
  { header: 'Mobile No', accessor: 'address.mobile' },
  { header: 'Doctor', accessor: 'consultant.name' },
  { header: 'Address', accessor: 'address.address' }
];

const initialIndoorRegisterationDataObj = {
  data: [],
  loading: false
};

export const IndoorRegisteration = () => {
  const { pathname } = useLocation();
  const lastPathSegment = pathname.split('/').pop();
  const pathParts = pathname.split('/');
  const organisation = pathParts[1];
  const [loading, setLoading] = useState(false);
  const [indoorRegisterationDataObj, setIndoorRegisterationDataObj] = useState(initialIndoorRegisterationDataObj);
  const [openQueryDialog, setOpenQueryDialog] = useState(false);
  const [currentAction, setCurrentAction] = useState();
  const [activeTab, setActiveTab] = useState(0);
  const [selectedRecord, setSelectedRecord] = useState();
  const [searchPatientRegisterationDialog, setSearchPatientRegisterationDialog] = useState(false);
  const [patientDetailList, setPatientDetailList] = useState([]);

  const [doctorDropdown, setDoctorDropdown] = useState([]);
  const [departmentDropdown, setDepartmentDropdown] = useState([]);
  const [referralDropdown, setReferralDropdown] = useState([]);
  const [wardDropdown, setWardDropdown] = useState([]);
  const [doctorUnitDropdown, setDoctorUnitDropdown] = useState([]);
  const [departmentUnitDropdown, setDepartmentUnitDropdown] = useState([]);
  const [roomMasterDropdown, setRoomMasterDropdown] = useState([]);
  const [admissionTypeDropdown,setAdmissionTypeDropdown] = useState([])
  const [sponsorDropdown, setSponsorDropdown] = useState([]);
  const [rankDropdown, setRankDropdown] = useState([]);
  const [nursingStationDropdown, setNursingStationDropdown] = useState([]);
  const [stateName, setStateName] = useState([]);
  const [cityName, setCityName] = useState([]);
  const [input, setInput] = useState('');
  const [isFiltered, setIsFiltered] = useState(false);
  const [originalData, setOriginalData] = useState([]);
  const [patientDataList, setPatientDataList] = useState([]);
  const [startDateInput, setStartDateInput] = useState('');
  const [endDateInput, setEndDateInput] = useState('');
  const user = JSON.parse(localStorage.getItem('user'));
  const isEnabledDate =
    user && user.permissions ? user.permissions.some((permission) => permission.includes('DatePermission')) : false;

  const getNursingStationDropdown = useCallback(async () => {
    const data = await dropdownFetch('nursing-station');
    if (!selectedRecord) {
      const [defaultReferal] = data.filter(({ status }) => status === 'default');
      setValue('register.consultant_detail.nursing_station', defaultReferal?._id);
    }
    setNursingStationDropdown(data);
  }, []);
  const getRankDropdown = useCallback(async () => {
    const data = await dropdownFetch('rank-master');
    setRankDropdown(data);
  }, []);
  const getSponsorDropdown = useCallback(async () => {
    const data = await dropdownFetch('sponsor');
    setSponsorDropdown(data);
  }, []);
  const getRoomMasterDropdown = useCallback(async () => {
    const data = await dropdownFetch('room-master');
    setRoomMasterDropdown(data);
  }, []);
  const getDepartmentUnitDropdown = useCallback(async () => {
    const data = await dropdownFetch('department-unit');
    if (!selectedRecord) {
      const [defaultReferal] = data.filter(({ status }) => status === 'default');
      setValue('register.consultant_detail.department_unit', defaultReferal?._id);
    }
    setDepartmentUnitDropdown(data);
  }, []);
  const getDoctorUnitDropdown = useCallback(async () => {
    const data = await dropdownFetch('doctor-unit');
    setDoctorUnitDropdown(data);
  }, []);
  const getWardDropdown = useCallback(async () => {
    const data = await dropdownFetch('ward');
    setWardDropdown(data);
  }, []);
  const getReferralDropdown = useCallback(async () => {
    const data = await dropdownFetch('referral');
    if (!selectedRecord) {
      const [defaultReferal] = data.filter(({ status }) => status === 'default');
      setValue('register.consultant_detail.referred_by', defaultReferal?._id);
    }
    setReferralDropdown(data);
  }, []);
  const getDepartmentDropdown = useCallback(async () => {
    const data = await dropdownFetch('department');
    setDepartmentDropdown(data);
  }, []);
  const getDoctorDropdown = useCallback(async () => {
    const data = await dropdownFetch('doctor');
    setDoctorDropdown(data);
  }, []);
  const getStateDropdown = useCallback(async () => {
    const data = await dropdownFetch('state');
    if (!selectedRecord) {
      const [defaultState] = data.filter(({ status }) => status === 'default');
      setValue('address.state', defaultState?._id);
    }
    setStateName(data);
  }, []);

  const getCityDropdown = useCallback(async () => {
    const data = await dropdownFetch('city');
    if (!selectedRecord) {
      const [defaultState] = data.filter(({ status }) => status === 'default');
      setValue('address.city', defaultState?._id);
    }
    setCityName(data);
  }, []);

  const getAdmissionTypeDropdown = useCallback(async () => {
    const data = await dropdownFetch('admission-type');
    if (!selectedRecord) {
      const [defaultAdmissionType] = data.filter(({ status }) => status === 'default');
      setValue('register.adm_type', defaultAdmissionType?._id);
    }
    setAdmissionTypeDropdown(data);
  }, []);


  useEffect(() => {
    getWardDropdown();
    getDoctorDropdown();
    getSponsorDropdown();
    getRankDropdown();
    getDepartmentUnitDropdown();
    getDepartmentDropdown();
    getReferralDropdown();
    getDoctorUnitDropdown();
    getRoomMasterDropdown();
    getNursingStationDropdown();
    getStateDropdown();
    getCityDropdown();
    getAdmissionTypeDropdown()
  }, [
    getDoctorDropdown,
    getNursingStationDropdown,
    getRankDropdown,
    getRoomMasterDropdown,
    getSponsorDropdown,
    getDoctorUnitDropdown,
    getWardDropdown,
    getReferralDropdown,
    getDepartmentDropdown,
    getDepartmentUnitDropdown,
    getStateDropdown,
    getCityDropdown,
    getAdmissionTypeDropdown
  ]);

  const methods = useForm({
    resolver: yupResolver(
      Yup.object().shape({
        uhid: Yup.string().required(' '),
        gender: Yup.string().required(' '),
        dob: Yup.date().required(' '),
        address: Yup.object().shape({
          // country: Yup.string().required(' '),
          // state: Yup.string().required(' '),
          // city: Yup.string().required(' '),
          // mobile: Yup.string().required(' ')
        }),
        sponsor: Yup.string().required(' '),
        register: Yup.object().shape({
          // marital: Yup.string().required(' '),
          // dom: Yup.date().required(' '),
          adm_type: Yup.string().required(' '),
          care_taker: Yup.object().shape({
            name_1: Yup.string().required(' '),
            mobile_1: Yup.string()
            .required('Mobile number is required')
            .matches(/^\d{10}$/, 'Mobile number must be exactly 10 digits'),
            relation_1: Yup.string().required('')
          }),
          consultant_detail: Yup.object().shape({
            doctor: Yup.string().required(' '),
            // referred_type: Yup.string().required(' '),
            referred_by: Yup.string().required(' '),
            bed_no: Yup.string().required(' '),
            department: Yup.string().required(' '),
            ward: Yup.string().required(' '),
            department_unit: Yup.string().required(' '),
            room: Yup.string().required(' ')
          })
        })
      })
    ),
    defaultValues: {
      // jr_res_doc: null
      register: {
        adm_type: 'Normal',
        date: getISTDate(),
        time: new Date().toLocaleTimeString('en-US', { hour12: false }).slice(0, 5)
      }
    },
    mode: 'all'
  });

  const { handleSubmit, watch, setValue, reset } = methods;

  useEffect(() => {
    if (selectedRecord) {
      console.log(selectedRecord, 'HELLO THE SELECTED RECORD IS HERE ROOOMS');
      const keyValuePair = getKeyPathValue(selectedRecord, 'register', [
        '_id',
        'dom',
        '__v',
        'çreatedAt',
        'register.tpa.referral_date',
        'status',
        'uhid'
      ]);
      keyValuePair.forEach(({ key, value }) => setValue(key, value));
      setValue('dom', getCurrentDateTime('register.date', selectedRecord.dom)?.split('-').reverse().join('-'));
      const formattedRegDate = selectedRecord?.date ? new Date(selectedRecord.date).toISOString().split('T')[0] : '';
      setValue('register.date', formattedRegDate);
      setValue('register.time', selectedRecord?.time);
      setValue(
        'register.tpa.referral_date',
        getCurrentDateTime('register.date', selectedRecord?.tpa?.referral_date)?.split('-').reverse().join('-')
      );
      setValue('uhid', selectedRecord.uhid);
      setValue('register.consultant_detail.doctor', selectedRecord?.consultant_detail?.doctor?._id);
      setValue('register.consultant_detail.department', selectedRecord?.consultant_detail?.department?._id);
      setValue('register.consultant_detail.department_unit', selectedRecord?.consultant_detail?.department_unit?._id);
      setValue('register.consultant_detail.nursing_station', selectedRecord?.consultant_detail?.nursing_station?._id);
      setValue('register.consultant_detail.ward', selectedRecord?.consultant_detail?.ward?._id);
      setValue('register.consultant_detail.room', selectedRecord?.consultant_detail?.room);
      handlePatientSearch(selectedRecord.uhid);
    } else {
      reset();
    }
  }, [setValue, reset, selectedRecord]);

  const handleActiveTab = (newTabIndex) => {
    setActiveTab(newTabIndex);
  };

  const roomWatch = watch('register.consultant_detail.room');
  useEffect(() => {
    if (!roomWatch) return;
    setValue(
      'register.consultant_detail.ward_charges',
      roomMasterDropdown.filter((data) => data._id === roomWatch)[0]?.charge
    );
  }, [roomWatch, roomMasterDropdown, setValue]);

  const bedNoWatch = watch('register.consultant_detail.bed_no');
  useEffect(() => {
    if (!bedNoWatch) return;
    setValue(
      'register.consultant_detail.cradle',
      roomMasterDropdown
        .filter((data) => data._id === roomWatch)[0]
        ?.beds?.filter((data) => data.bed_no === bedNoWatch)[0]?.cradle_charge
    );
  }, [bedNoWatch, setValue, roomWatch, roomMasterDropdown]);

  const dobWatch = watch('dob');
  useEffect(() => {
    if (!dobWatch) return;
    const dobDate = new Date(dobWatch);
    if (dobDate >= Date.now()) {
      toast('DOB cannot be of future', { variant: 'error' });
      return;
    }
    const { year, month, day } = getDateDifference(new Date(dobWatch));
    setValue('age_year', year);
    setValue('age_month', month);
    setValue('age_day', day);
  }, [setValue, dobWatch]);

  const domWatch = watch('register.dom');
  useEffect(() => {
    if (!domWatch) return;
    const domDate = new Date(domWatch);
    if (domDate >= Date.now()) {
      toast('DOM cannot be of future', { variant: 'error' });
    }
  }, [setValue, domWatch]);

  const formSubmit = async (formValue) => {
    setLoading(true);
    let editFlag = false;
    if (selectedRecord && currentAction === 'edit') {
      editFlag = true;
    }
    const response = await request(editFlag ? '/indoor-registeration-update' : '/indoor-registeration-create', {
      method: editFlag ? 'PUT' : 'POST',
      params: editFlag ? selectedRecord._id : null,
      body: {
        uhid: formValue.uhid,
        ...formValue,
        ...formValue.register,
        createdBy: user.name,
        updatedBy: editFlag ? user.name : '',
        organisation
      }
    });
    console.log("response-submit",response);
    if (!response?.success) {
      toast(`${response?.message}`, { variant: 'warning' });
    } else if (response?.success) {
            const message = `Dear ${response?.data?.care_taker.name_1},
UHID No. ${response?.data.uhid}
IPD No. ${response?.data.ipd_no}
Welcome to ${user.nameOfOrg}.
We are honored that you have chosen us for your healthcare needs.
We wish you a smooth and speedy recovery and are here to support you every step of the way.
Warm regards,
The ${user.nameOfOrg} Team`;
            const responsee = axios.post(`${BASE_URL}/proxy/send`, {
              number: `${response.data?.care_taker.mobile_1}`,
              type: 'text',
              message: encodeURIComponent(message)
            });
      toast(`Successfully ${editFlag ? 'updated' : 'created'} Indoor Registeration`, { variant: 'success' });
      setSelectedRecord(response?.data);
      setCurrentAction();
      reset();
      getRoomMasterDropdown();
    } else {
      toast(`Failed to ${editFlag ? 'update' : 'create'} Indoor Registeration`, {
        variant: 'error'
      });
    }
    setLoading(false);
  };

  const handleCancelRecord = async () => {
    setLoading(true);
    const response = await request('/indoor-registeration-cancel', {
      method: 'DELETE',
      params: selectedRecord._id
    });
    if (response?.success) {
      toast('Successfully Cancelled Indoor Registeration', { variant: 'success' });
      setSelectedRecord();
    } else {
      toast('Failed to Cancelled Indoor Registeration', { variant: 'error' });
    }
    setLoading(false);
  };

  const handleDeleteRecord = async () => {
    setLoading(true);
    const response = await request('/indoor-registeration-delete', {
      method: 'DELETE',
      params: selectedRecord._id
    });
    if (response?.success) {
      toast('Successfully deleted Indoor Registeration', { variant: 'success' });
      setSelectedRecord();
    } else {
      toast('Failed to delete Indoor Registeration', { variant: 'error' });
    }
    setLoading(false);
  };

  useEffect(() => {
    if (indoorRegisterationDataObj.data && indoorRegisterationDataObj.data.length > 0) {
      setOriginalData(indoorRegisterationDataObj.data);
      setIsFiltered(false);
    }
  }, [indoorRegisterationDataObj.data]);

  const handleUhidSearch = async () => {
    const lowercasedInput = input.toLowerCase().trim();
    try {
      const query = {};
      if (startDateInput && endDateInput) {
        query.startDate = startDateInput;
        query.endDate = endDateInput;
      }
      if (lowercasedInput) {
        query.name = lowercasedInput;
      }
      const response = await request('/indoor-registeration-list', {
        method: 'GET',
        query: query
      });
      if (response.success) {
        const sortedData = response.data.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
        const filteredData = sortedData.filter(
          (item) => item.status === 'active' || item.status === 'inactive' || item.status === 'default'
        );
        setIndoorRegisterationDataObj({ loading: false, data: filteredData });
        setOriginalData(sortedData);
      } else {
        toast('Error in fetching data', { variant: 'error' });
        setIndoorRegisterationDataObj({ loading: false });
      }
    } catch (error) {
      console.error('Error during search:', error);
      toast('Error during search', { variant: 'error' });
      setOriginalData({ loading: false, data: [] });
    }
  };

  const handleChange = (e) => {
    const newInput = e.target.value;
    setInput(newInput);
  };

  useEffect(() => {
    handleUhidSearch(input);
  }, [input]);

  useEffect(() => {
    if (patientDetailList.data && patientDetailList.data.length > 0) {
      setPatientDataList(patientDetailList.data);
      setIsFiltered(false);
    }
  }, [patientDetailList.data]);

  const handlePatient = async () => {
    const lowercasedInput = input.toLowerCase().trim();

    try {
      const response = await request('/patient-registeration-search', {
        method: 'GET',
        query: { name: lowercasedInput }
      });
      if (response.success) {
        setPatientDataList(response.data);
      } else {
        toast('Error in fetching dataaaaa', { variant: 'error' });
        setPatientDataList({ loading: false, data: [] });
      }
    } catch (error) {
      console.error('Error during search:', error);
      toast('Error during search', { variant: 'error' });
      setPatientDataList({ loading: false, data: [] });
    }
  };

  const handlePatientChange = (e) => {
    const newInput = e.target.value;
    setInput(newInput);
  };

  useEffect(() => {
    handlePatient(input);
  }, [input]);

  const handleQueryWindow = async () => {
    setOpenQueryDialog(true);
    setIndoorRegisterationDataObj({ loading: true });
    const response = await request('/indoor-registeration-list', { method: 'GET' });
    if (response.success) {
      const sortedData = response.data.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
      const filteredData = sortedData.filter(
        (item) => item.status === 'active' || item.status === 'inactive' || item.status === 'default'
      );
      setIndoorRegisterationDataObj({ loading: false, data: filteredData });
      setOriginalData(sortedData);
    } else {
      toast('Error in fetching data', { variant: 'error' });
      setIndoorRegisterationDataObj({ loading: false });
    }
  };

  const handlePatientSearch = async (uhid = null) => {
    if (typeof uhid !== 'number' && typeof uhid !== 'string') uhid = null;
    setLoading(true);
    if (!uhid) setSearchPatientRegisterationDialog(true);
    const response = await request('/patient-registeration-search', { method: 'GET', query: { uhid } });
    if (response?.success) {
      if (uhid) {
        const {
          data: [patientData]
        } = response;
        setValue('dob', getCurrentDateTime('register.date', patientData?.dob)?.split('-').reverse().join('-'));
        setValue('address', patientData?.address);
        setValue('visit_no', patientData?.visit_no);
        setValue('patient_name', `${patientData?.first_name} ${patientData?.last_name}`);
        setValue('patient_suffix', patientData?.name_suffix);
        setValue('gender', patientData?.gender);
        setValue('guardian_type', patientData?.guardian_type?.name);
        setValue('guardian_name', patientData?.guardian_name);
        setValue('patient_type', patientData?.patient_type?.type);
        setValue('sponsor', patientData?.sponsor?.name);
        setValue('vertical', patientData?.vertical?.verticalname);
      } else {
        const sortedData = response.data.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));

        console.log("sortedData",sortedData)
        const filteredData = await Promise.all(
          sortedData.map(async (patient) => {
            const checkResponse = await request('/indoor-registeration-check-uhid', {
              method: 'GET',
              query: { uhid: patient.uhid }
            });
            return checkResponse?.success && checkResponse.data?.isPresent ? null : patient;
          })
        );
        setPatientDetailList(filteredData.filter(Boolean));
        setPatientDataList(filteredData.filter(Boolean));
      }
    } else {
      toast('Failed to load patient details', { variant: 'error' });
    }
    setLoading(false);
  };

  const handlePatientRowClick = async (row) => {
    setLoading(true);
    const response = await request('/indoor-registeration-check-uhid', { method: 'GET', query: { uhid: row.uhid } });
    if (response?.success) {
      if (response?.data?.isPresent) {
        toast('Patient already registered', { variant: 'error' });
        return;
      }
    } else {
      toast('Failed to verify patient registeration details', { variant: 'error' });
      return;
    }
    setLoading(false);
    console.log(row,"THE ROW IS HERE....")
    setValue('uhid', row.uhid);
    setValue('dob', row.dob?.split('T')[0]);
    setValue('address', row.address);
    setValue('visit_no', row.visit_no);
    setValue('patient_name', `${row?.first_name} ${row?.last_name}`);
    setValue('patient_suffix', row.name_suffix);
    setValue('gender', row.gender);
    setValue('guardian_type', row.guardian_type?.name);
    setValue('guardian_name', row.guardian_name);
    setValue('patient_type', row.patient_type?.type);
    setValue('sponsor', row.sponsor?.name);
    setValue('vertical', row.vertical?.verticalname);
    setSearchPatientRegisterationDialog(false);
  };

  const handleStartChangeDate = (e) => {
    setStartDateInput(e.target.value);
  };

  const handleEndChangeDate = (e) => {
    setEndDateInput(e.target.value);
  };

  const handleSearchByDate = async () => {
    setIndoorRegisterationDataObj({ loading: true, data: [] });
    try {
      const query = {};
      if (startDateInput && endDateInput) {
        query.startDate = startDateInput;
        query.endDate = endDateInput;
      }
      const response = await request('/indoor-registeration-list', {
        method: 'GET',
        query: query
      });
      if (response.success) {
        const sortedData = response.data.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
        const filteredData = sortedData.filter(
          (item) => item.status === 'active' || item.status === 'inactive' || item.status === 'default'
        );
        setIndoorRegisterationDataObj({ loading: false, data: filteredData });
        setOriginalData(sortedData);
      } else {
        toast('Error in fetching data', { variant: 'error' });
        setIndoorRegisterationDataObj({ loading: false });
      }
    } catch (error) {
      console.error('Error during search:', error);
      toast('Error during search', { variant: 'error' });
      setIndoorRegisterationDataObj({ loading: false, data: [] });
    }
  };

  const mobile1 = watch('register.care_taker.mobile_1')
  const mobile2 = watch('register.care_taker.mobile_2')

  const isRqtyInvalid = 10 >= mobile1; 
  const isRqtyInvalid2 = 10 >= mobile2; 

  const fetchLatestIpdNo = async()=>{
   const response = await request('/indoor-registeration-latest-ipd',{method:"GET"})
   try{
    if(response.success){
      setValue('register.ipd_no',response.ipd_no)
    }
   }catch(err){
    console.log(err)
   }
  }

  useEffect(()=>{
      fetchLatestIpdNo()
  },[])

  return (
    <>
      <Paper
        sx={{
          p: 0,
          flex: 1,
          borderRadius: 0,
          boxShadow: 'none',
          width: '100%',
          height: 'auto'
        }}
      >
        <Container
          sx={{
            mt: 1,
            border: '0px solid',
            borderColor: 'grey.300',
            borderRadius: 1,
            width: '100%',
            maxWidth: '100vw',
            boxSizing: 'border-box',
            minWidth: '100%'
          }}
        >
          <FormProvider methods={methods} onSubmit={handleSubmit(formSubmit)}>
            <Stack
              direction="row"
              spacing={2}
              justifyContent="space-between"
              alignItems="center"
              sx={{
                mb: 1,
                borderBottom: '0px solid',
                borderColor: 'grey.300'
              }}
            >
              <Typography color="primary" variant="h3" sx={{ fontWeight: 600 }}>
                IPD Registeration
              </Typography>
              <Stack direction="row" justifyContent="flex-end" sx={{ mb: 3 }} spacing={1}>
                <CustomButtonn
                  id={`${lastPathSegment}Write`}
                  variant="contained"
                  disabled={['edit', 'new'].includes(currentAction)}
                  onClick={() => {
                    setSelectedRecord();
                    setCurrentAction('new');
                  }}
                >
                  New
                </CustomButtonn>
                <CustomButtonn
                  id={`${lastPathSegment}Update`}
                  variant="contained"
                  disabled={['new', 'edit'].includes(currentAction) || !selectedRecord}
                  onClick={() => setCurrentAction('edit')}
                >
                  Edit
                </CustomButtonn>
                <CustomButtonn
                  id={'Submit'}
                  type="submit"
                  variant="contained"
                  disabled={!['edit', 'new'].includes(currentAction) || loading}
                >
                  Save
                </CustomButtonn>
                <CustomButtonn
                  id={'Cancel'}
                  variant="contained"
                  disabled={!selectedRecord || currentAction}
                  onClick={() => {
                    setCurrentAction();
                    handleCancelRecord();
                  }}
                >
                  Cancel
                </CustomButtonn>
                <CustomButtonn
                  id={`isSuperAdmin`}
                  variant="contained"
                  disabled={!selectedRecord || ['new', 'edit'].includes(currentAction) || loading}
                  onClick={handleDeleteRecord}
                >
                  Delete
                </CustomButtonn>
                <CustomButtonn
                  id={`${lastPathSegment}Read`}
                  variant="contained"
                  onClick={handleQueryWindow}
                  disabled={['new', 'edit'].includes(currentAction)}
                >
                  Query
                </CustomButtonn>
                <CustomButtonn
                  id={`${lastPathSegment}Print`}
                  variant="contained"
                  onClick={() => window.open(`/print${pathname}?refId=${selectedRecord._id}`, '_blank')}
                  disabled={!selectedRecord || currentAction}
                >
                  Print
                </CustomButtonn>
                <CustomButtonn
                  id={`${lastPathSegment}Print`}
                  variant="contained"
                  onClick={() => window.open(`/print${pathname}/print1?refId=${selectedRecord._id}`, '_blank')}
                  disabled={!selectedRecord || currentAction}
                >
                  Print1
                </CustomButtonn>
                <CustomButtonn
                  id={`${lastPathSegment}Print`}
                  variant="contained"
                  onClick={() => window.open(`/print${pathname}/label?refId=${selectedRecord._id}`, '_blank')}
                  disabled={!selectedRecord || currentAction}
                >
                  Label
                </CustomButtonn>
                <CustomButtonn
                  id={'Exit'}
                  variant="contained"
                  onClick={() => {
                    setCurrentAction('');
                  }}
                >
                  Exit
                </CustomButtonn>
              </Stack>
            </Stack>
            <Box
              sx={{
                border: '0px solid gray',
                padding: 2,
                borderRadius: '8px',
                width: '100%',
                boxShadow: '0px 2px 10px #0099ff'
              }}
            >
              <Stack sx={{ mb: 0.3 }} direction="row" spacing={2}>
                <Stack spacing={0.5} direction="row" alignItems="center" sx={{ flex: 1 / 3 }}>
                  <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>UHID/Visit No.</Typography>
                  <TextField disabled sx={{ flex: 0.4 }} name="uhid" placeholder="UHID" />
                  <TextField disabled sx={{ flex: 0.3 }} name="visit_no" />
                  <Button
                    disabled={!['new'].includes(currentAction)}
                    sx={{ flex: 0.1, minWidth: 0, p: 0.25, height: '100%' }}
                    variant="contained"
                    onClick={handlePatientSearch}
                  >
                    <SearchIcon />
                  </Button>
                </Stack>
                <Stack spacing={0.5} direction="row" alignItems="center" sx={{ flex: 1 / 3 }}>
                  <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>IPD/Reg No.</Typography>
                  <TextField sx={{ flex: 0.4 }} name="register.ipd_no" disabled />
                  <TextField
                    sx={{ flex: 0.4 }}
                    name="register.ref_no"
                    disabled={!['new', 'edit'].includes(currentAction)}
                  />
                </Stack>
                <Stack spacing={0.5} direction="row" alignItems="center" sx={{ flex: 1 / 3 }}>
                  <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>Reg. Date/Time</Typography>
                  <TextField
                    sx={{ flex: 0.5 }}
                    name="register.date"
                    type="date"
                    placeholder="Date"
                    disabled={!isEnabledDate || !['new', 'edit'].includes(currentAction)}
                  />
                  <TextField
                    sx={{ flex: 0.3 }}
                    name="register.time"
                    type="time"
                    placeholder="Time"
                    disabled={!isEnabledDate || !['new', 'edit'].includes(currentAction)}
                  />
                </Stack>
              </Stack>

              <Stack sx={{ mb: 0.3 }} direction="row" spacing={2}>
                <Stack spacing={0.5} direction="row" alignItems="center" sx={{ flex: 1 / 3 }}>
                  <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>Patient Name</Typography>
                  <TextField sx={{ flex: 0.2 }} name="patient_suffix" disabled />
                  <TextField sx={{ flex: 0.6 }} name="patient_name" disabled />
                </Stack>
                <Stack spacing={0.5} direction="row" alignItems="center" sx={{ flex: 1 / 3 }}>
                  <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>Guardian</Typography>
                  <TextField disabled sx={{ flex: 0.2 }} name="guardian_type" placeholder="Guardian Type" />
                  <TextField disabled sx={{ flex: 0.6 }} name="guardian_name" placeholder="Guardian Name" />
                </Stack>
                <Stack spacing={0.5} direction="row" alignItems="center" sx={{ flex: 1 / 3 }}>
                  <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>Gender</Typography>
                  <SelectTag disabled formControlSX={{ flex: 0.8 }} name="gender" menus={GENDER_DROPDOWN} />
                </Stack>
              </Stack>
              <Stack sx={{ mb: 0.3 }} direction="row" spacing={2}>
                <Stack spacing={0.5} direction="row" alignItems="center" sx={{ flex: 1 / 3 }}>
                  <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>Age</Typography>
                  <TextField sx={{ flex: 0.8 / 3 }} name="age_year" type="number" disabled />
                  <TextField sx={{ flex: 0.8 / 3 }} name="age_month" type="number" disabled />
                  <TextField sx={{ flex: 0.8 / 3 }} name="age_day" type="number" disabled />
                </Stack>
                <Stack spacing={0.5} direction="row" alignItems="center" sx={{ flex: 1 / 3 }}>
                  <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>DOB</Typography>
                  <TextField disabled sx={{ flex: 0.8 }} type="date" name="dob" />
                </Stack>
                <Stack spacing={0.5} direction="row" alignItems="center" sx={{ flex: 1 / 3 }}>
                  <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>Mobile</Typography>
                  <TextField disabled sx={{ flex: 0.8 }} name="address.mobile" placeholder="Mobile No." />
                </Stack>
              </Stack>
              <Stack sx={{ mb: 0.3 }} direction="row" spacing={2}>
                <Stack spacing={0.5} direction="row" alignItems="center" sx={{ flex: 1 / 3 }}>
                  <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>Address</Typography>
                  <TextField sx={{ flex: 0.8 }} name="address.address" disabled />
                </Stack>
                <Stack spacing={0.5} direction="row" alignItems="center" sx={{ flex: 1 / 3 }}>
                  <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>Country</Typography>
                  <SelectTag
                    formControlSX={{ flex: 0.4 }}
                    menus={[{ _id: 'IN', name: 'India' }]}
                    disabled
                    name="address.country"
                  />
                  <SelectTag
                    formControlSX={{ flex: 0.4 }}
                    menus={[
                      ...(getStatesByCountry(watch('address.country')) || []),
                      ...stateName.map((data) => ({ ...data, name: data.state }))
                    ]}
                    disabled
                    name="address.state"
                    placeholder="Select State"
                  />
                </Stack>

                <Stack spacing={0.5} direction="row" alignItems="center" sx={{ flex: 1 / 3 }}>
                  <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>City</Typography>
                  <SelectTag
                    disabled
                    formControlSX={{ flex: 0.8 }}
                    name="address.city"
                    menus={[
                      ...(getCityByState(watch('address.country'), watch('address.state')) || []),
                      ...cityName.map((data) => ({ ...data, name: data.city }))
                    ]}
                  />
                </Stack>
              </Stack>

              <Stack sx={{ mb: 0.3 }} direction="row" spacing={2}>
                <Stack spacing={0.5} direction="row" alignItems="center" sx={{ flex: 1 / 3 }}>
                  <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>Marital / DOM</Typography>
                  <SelectTag
                    disabled={!['new', 'edit'].includes(currentAction)}
                    formControlSX={{ flex: 0.4 }}
                    name="register.marital"
                    menus={MARITAL_STATUS}
                    placeholder="Marital Status"
                  />
                  <TextField
                    sx={{ flex: 0.4 }}
                    disabled={!['new', 'edit'].includes(currentAction)}
                    type="date"
                    name="register.dom"
                  />
                </Stack>

                <Stack spacing={0.5} direction="row" alignItems="center" sx={{ flex: 1 / 3 }}>
                  <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>Sponsor</Typography>
                  <TextField disabled sx={{ flex: 0.8 }} name="sponsor" />
                </Stack>
                <Stack spacing={0.5} direction="row" alignItems="center" sx={{ flex: 1 / 3 }}>
                  <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>Adm. Type</Typography>
                  <SelectTag
                    disabled={!['new', 'edit'].includes(currentAction)}
                    formControlSX={{
                      flex: 0.8,
                      border: currentAction ? '0.5px solid red' : ''
                    }}
                    name="register.adm_type"
                    menus={admissionTypeDropdown.map((data)=> ({...data,name:data.admission_type}))}
                  />
                </Stack>
              </Stack>
              <Stack sx={{ mb: 0.3 }} direction="row" spacing={1}>
                <Stack spacing={0.3} direction="row" alignItems="center" sx={{ flex: 1 / 3 }}>
                  <Typography sx={{ flex: 0.267, fontWeight: 700, fontSize: '1.4rem' }}>MLC</Typography>
                  <SelectTag
                    formControlSX={{ flex: 0.72 }}
                    name="register.mlc"
                    menus={MLC}
                    disabled={!['new', 'edit'].includes(currentAction)}
                  />
                </Stack>
                <Stack spacing={0.4} direction="row" alignItems="center" sx={{ flex: 1 / 3 }}>
                  <Typography sx={{ flex: 0.27, fontWeight: 700, fontSize: '1.4rem' }}>MLC No.</Typography>
                  <TextField
                    disabled={!['new', 'edit'].includes(currentAction)}
                    sx={{ flex: 0.71 }}
                    name="register.mlc_no"
                    placeholder="MLC"
                  />
                </Stack>
              </Stack>
              <Grid container spacing={0}>
                <Grid item xs={4} sx={{ display: 'flex', gap: 1, flexDirection: 'column' }}></Grid>
                <Grid item xs={4} sx={{ display: 'flex', gap: 1, flexDirection: 'column' }}></Grid>
                <Grid item xs={12}>
                  <Box sx={{ borderBottom: '1px solid', borderColor: 'divider', marginBottom: '1%' }}>
                    <Button
                      variant="contained"
                      onClick={() => handleActiveTab(0)}
                      sx={{
                        my: 0,
                        mx: 0,
                        borderRadius: '4px',
                        fontWeight: 700
                      }}
                    >
                      Care Taker Details
                    </Button>
                    <Button
                      variant="contained"
                      onClick={() => handleActiveTab(1)}
                      sx={{
                        my: 0,
                        mx: 0.5,
                        borderRadius: '4px',
                        fontWeight: 700
                      }}
                    >
                      Consultant Details
                    </Button>
                  </Box>
                </Grid>
                {activeTab === 0 && (
                  <>
                    <Stack sx={{ mb: 0.3, width: '100%' }} direction="row" spacing={2}>
                      <Stack spacing={0.5} direction="row" alignItems="center" sx={{ flex: 1 / 3 }}>
                        <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>Name 1</Typography>
                        <TextField
                          disabled={!['new', 'edit'].includes(currentAction)}
                          sx={{
                            flex: 0.8,
                            border: currentAction ? '0.5px solid red' : ''
                          }}
                          name="register.care_taker.name_1"
                          placeholder="Enter Name 1"
                        />
                      </Stack>
                      <Stack spacing={0.5} direction="row" alignItems="center" sx={{ flex: 1 / 3 }}>
                        <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>Relation 1</Typography>
                        <SelectTag
                          disabled={!['new', 'edit'].includes(currentAction)}
                          formControlSX={{
                            flex: 0.8,
                            border: currentAction ? '0.5px solid red' : ''
                          }}
                          name="register.care_taker.relation_1"
                          menus={RELATION}
                        />
                      </Stack>
                      <Stack spacing={0.5} direction="row" alignItems="center" sx={{ flex: 1 / 3 }}>
                        <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>Mobile 1</Typography>
                        <TextField
                          disabled={!['new', 'edit'].includes(currentAction)}
                          sx={{
                            flex: 0.8,
                            border: currentAction ? '0.5px solid red' : ''
                          }}
                          name="register.care_taker.mobile_1"
                          placeholder="Enter Mobile 1"
                          error={isRqtyInvalid || (mobile1 && mobile1.length !== 10)}
                          helperText={
                            isRqtyInvalid
                              ? 'Mobile number must be exactly 10 digits'
                              : mobile1 && mobile1.length !== 10
                                ? 'Mobile number must be exactly 10 digits'
                                : ''
                          }
                        />
                      </Stack>
                    </Stack>
                    <Stack sx={{ mb: 0.3, width: '100%' }} direction="row" spacing={2}>
                      <Stack spacing={0.5} direction="row" alignItems="center" sx={{ flex: 1 / 3 }}>
                        <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>Name 2</Typography>
                        <TextField
                          disabled={!['new', 'edit'].includes(currentAction)}
                          sx={{
                            flex: 0.8
                          }}
                          name="register.care_taker.name_2"
                          placeholder="Enter Name 2"
                        />
                      </Stack>

                      <Stack spacing={0.5} direction="row" alignItems="center" sx={{ flex: 1 / 3 }}>
                        <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>Relation 2</Typography>
                        <SelectTag
                          disabled={!['new', 'edit'].includes(currentAction)}
                          formControlSX={{
                            flex: 0.8
                          }}
                          name="register.care_taker.relation_2"
                          menus={RELATION}
                        />
                      </Stack>
                      <Stack spacing={0.5} direction="row" alignItems="center" sx={{ flex: 1 / 3 }}>
                        <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>Mobile 2</Typography>
                        <TextField
                          disabled={!['new', 'edit'].includes(currentAction)}
                          sx={{
                            flex: 0.8
                          }}
                          name="register.care_taker.mobile_2"
                          placeholder="Enter Mobile 2"
                          error={isRqtyInvalid2 || (mobile2 && mobile2.length !== 10)}
                          helperText={
                            isRqtyInvalid2
                              ? 'Mobile number must be exactly 10 digits'
                              : mobile2 && mobile2.length !== 10
                                ? 'Mobile number must be exactly 10 digits'
                                : ''
                          }
                        />
                      </Stack>
                    </Stack>
                  </>
                )}
                {activeTab === 1 && (
                  <>
                    <Stack sx={{ mb: 0.3, width: '100%' }} direction="row" spacing={2}>
                      <Stack spacing={0.5} direction="row" alignItems="center" sx={{ flex: 1 / 3 }}>
                        <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>Doctor</Typography>
                        <SelectTag
                          disabled={!['new', 'edit'].includes(currentAction)}
                          formControlSX={{
                            flex: 0.8,
                            border: currentAction ? '0.5px solid red' : ''
                          }}
                          name="register.consultant_detail.doctor"
                          menus={doctorDropdown}
                          onChange={({ target: { row } }) => {
                            setValue('register.consultant_detail.department', row.qualification_details.department);
                          }}
                        />
                      </Stack>
                      <Stack spacing={0.5} direction="row" alignItems="center" sx={{ flex: 1 / 3 }}>
                        <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>Department</Typography>
                        <SelectTag
                          disabled={!['new', 'edit'].includes(currentAction)}
                          formControlSX={{
                            flex: 0.8,
                            border: currentAction ? '0.5px solid red' : ''
                          }}
                          name="register.consultant_detail.department"
                          menus={departmentDropdown.map((data) => ({ ...data, name: data.department }))}
                        />
                      </Stack>
                      <Stack spacing={0.5} direction="row" alignItems="center" sx={{ flex: 1 / 3 }}>
                        <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>Referred By</Typography>
                        <SelectTag
                          disabled={!['new', 'edit'].includes(currentAction)}
                          formControlSX={{
                            flex: 0.8,
                            border: currentAction ? '0.5px solid red' : ''
                          }}
                          name="register.consultant_detail.referred_by"
                          menus={referralDropdown.map((data) => ({ ...data, name: data.referral_name }))}
                        />
                      </Stack>
                    </Stack>

                    <Stack sx={{ mb: 0.3, width: '100%' }} direction="row" spacing={2}>
                      <Stack spacing={0.5} direction="row" alignItems="center" sx={{ flex: 1 / 3 }}>
                        <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>Dept. Unit</Typography>
                        <SelectTag
                          disabled={!['new', 'edit'].includes(currentAction)}
                          formControlSX={{
                            flex: 0.8,
                            border: currentAction ? '0.5px solid red' : ''
                          }}
                          name="register.consultant_detail.department_unit"
                          menus={departmentUnitDropdown.map((data) => ({ ...data, name: data.name }))}
                          onChange={() => {
                            setValue('register.consultant_detail.nursing_station', '');
                            setValue('register.consultant_detail.ward', '');
                            setValue('register.consultant_detail.room', '');
                            setValue('register.consultant_detail.bed_no', '');
                          }}
                        />
                      </Stack>
                      <Stack spacing={0.5} direction="row" alignItems="center" sx={{ flex: 1 / 3 }}>
                        <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>Nursing Station</Typography>
                        <SelectTag
                          disabled={!['new', 'edit'].includes(currentAction)}
                          formControlSX={{
                            flex: 0.8,
                            border: currentAction ? '0.5px solid red' : ''
                          }}
                          name="register.consultant_detail.nursing_station"
                          menus={nursingStationDropdown.map((data) => ({ ...data, name: data.name }))}
                          onChange={() => {
                            setValue('register.consultant_detail.room', '');
                            setValue('register.consultant_detail.bed_no', '');
                          }}
                        />
                      </Stack>
                      <Stack spacing={0.5} direction="row" alignItems="center" sx={{ flex: 1 / 3 }}>
                        <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>Ward Name</Typography>
                        <SelectTag
                          disabled={!['new', 'edit'].includes(currentAction)}
                          formControlSX={{
                            flex: 0.8,
                            border: currentAction ? '0.5px solid red' : ''
                          }}
                          name="register.consultant_detail.ward"
                          onChange={() => {
                            setValue('register.consultant_detail.room', '');
                            setValue('register.consultant_detail.bed_no', '');
                          }}
                          menus={wardDropdown}
                        />
                      </Stack>
                    </Stack>
                    <Stack sx={{ mb: 0.3, width: '100%' }} direction="row" spacing={2}>
                      <Stack spacing={0.5} direction="row" alignItems="center" sx={{ flex: 1 / 3 }}>
                        <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>Room</Typography>
                        <SelectTag
                          disabled={!['new', 'edit'].includes(currentAction)}
                          formControlSX={{
                            flex: 0.8,
                            border: currentAction ? '0.5px solid red' : ''
                          }}
                          name="register.consultant_detail.room"
                          menus={roomMasterDropdown
                            .filter(
                              (data) =>
                                data.nurse_station === watch('register.consultant_detail.nursing_station') &&
                                data.ward === watch('register.consultant_detail.ward') &&
                                data.department_unit === watch('register.consultant_detail.department_unit')
                            )
                            .map((data) => ({ ...data, name: data.room_no }))}
                          onChange={() => {
                            setValue('register.consultant_detail.bed_no', '');
                          }}
                        />
                      </Stack>
                      <Stack spacing={0.5} direction="row" alignItems="center" sx={{ flex: 1 / 3 }}>
                        <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>Bed No.</Typography>
                        <SelectTag
                          disabled={!['new', 'edit'].includes(currentAction)}
                          formControlSX={{
                            flex: 0.8,
                            border: currentAction ? '0.5px solid red' : ''
                          }}
                          name="register.consultant_detail.bed_no"
                          menus={roomMasterDropdown
                            .filter((data) => data._id === watch('register.consultant_detail.room'))[0]
                            ?.beds?.map((bed) => ({
                              _id: bed.bed_no,
                              name: bed.bed_no,
                              occupy_status: bed.occupy_status
                            }))}
                        />
                      </Stack>

                      <Stack spacing={0.5} direction="row" alignItems="center" sx={{ flex: 1 / 3 }}>
                        <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>Ward Charges</Typography>
                        <TextField disabled sx={{ flex: 0.8 }} name="register.consultant_detail.ward_charges" />
                      </Stack>
                    </Stack>
                    <Stack sx={{ mb: 0.3, width: '100%' }} direction="row" spacing={2}>
                      <Stack spacing={0.5} direction="row" alignItems="center" sx={{ flex: 1 / 3 }}>
                        <Typography sx={{ flex: 0.26, fontWeight: 700, fontSize: '1.4rem' }}>
                          Additional Doctor
                        </Typography>
                        <SelectTag
                          disabled={!['new', 'edit'].includes(currentAction)}
                          formControlSX={{ flex: 0.72 }}
                          name="register.consultant_detail.jr_res_doc"
                          menus={doctorDropdown}
                        />
                      </Stack>
                      <Stack spacing={0.5} direction="row" alignItems="center" sx={{ flex: 1 / 3 }}>
                        <Typography sx={{ flex: 0.26, fontWeight: 700, fontSize: '1.4rem' }}>Remarks</Typography>
                        <TextField
                          disabled={!['new', 'edit'].includes(currentAction)}
                          sx={{ flex: 0.72 }}
                          name="register.consultant_detail.remarks"
                        />
                      </Stack>
                    </Stack>
                  </>
                )}
              </Grid>
            </Box>
          </FormProvider>
        </Container>
      </Paper>
      <Dialog
        open={openQueryDialog}
        onClose={() => {
          setOpenQueryDialog(false);
        }}
        PaperProps={{ sx: { width: '80%', p: 2 } }}
        maxWidth="xl"
        scroll="body"
      >
        <Stack
          padding={0}
          direction="row"
          spacing={2}
          alignItems="center"
          justifyContent="space-between"
          borderBottom="1px solid"
          borderColor="grey.300"
        >
          <Typography variant="h4" fontWeight="bold">
            Indoor Registeration Query Window
          </Typography>
          <IconButton
            onClick={() => {
              setOpenQueryDialog(false);
              setStartDateInput('');
              setEndDateInput('');
            }}
          >
            <CloseIcon color="error" fontSize="large" />
          </IconButton>
        </Stack>
        <Stack direction="row" spacing={2} alignItems="center" justifyContent="center" sx={{ mt: 0 }}>
          <MuiTextField
            sx={{
              width: '100%',
              '& .MuiOutlinedInput-root': {
                padding: '0',
                fontSize: '1.4rem' // Adjust input font size
              },
              '& .MuiOutlinedInput-input': {
                padding: '8px 1.4rem'
              },
              '& .MuiInputLabel-root': {
                fontSize: '1.2rem' // Adjust label font size
              }
            }}
            label="Search Patient"
            variant="outlined"
            value={input}
            onChange={handleChange}
          />
        </Stack>
        <Stack
          direction="row"
          spacing={2}
          alignItems="center"
          justifyContent="center"
          sx={{
            mt: 1,
            mb: 1,
            width: '60%',
            gap: 2,
            justifyContent: 'space-between'
          }}
        >
          <Typography
            sx={{
              flex: 1,
              fontWeight: 700,
              fontSize: '1.4rem',
              textAlign: 'center' // Centers the label text
            }}
          >
            From Date
          </Typography>

          <MuiTextField
            sx={{
              flex: 2, // This ensures the input takes more space
              '& .MuiOutlinedInput-root': {
                padding: '0',
                fontSize: '14px'
              },
              '& .MuiOutlinedInput-input': {
                padding: '8px 14px'
              },
              '& .MuiInputLabel-root': {
                fontSize: '1.2rem' // Adjust label font size
              }
            }}
            variant="outlined"
            name="from_date"
            type="date"
            onChange={handleStartChangeDate}
            value={startDateInput}
          />

          <Typography
            sx={{
              flex: 1,
              fontWeight: 700,
              fontSize: '1.4rem',
              textAlign: 'center' // Centers the label text
            }}
          >
            To Date
          </Typography>
          <MuiTextField
            sx={{
              flex: 2, // This ensures the input takes more space
              '& .MuiOutlinedInput-root': {
                padding: '0',
                fontSize: '14px'
              },
              '& .MuiOutlinedInput-input': {
                padding: '8px 14px'
              },
              '& .MuiInputLabel-root': {
                fontSize: '1.2rem' // Adjust label font size
              }
            }}
            name="to_date"
            variant="outlined"
            type="date"
            onChange={handleEndChangeDate}
            value={endDateInput}
          />
          <Button variant="contained" disabled={!startDateInput || !endDateInput} onClick={handleSearchByDate}>
            Search
          </Button>
        </Stack>
        <Table
          sx={{ mt: 0.5 }}
          columns={TABLE_COLUMNS}
          data={originalData || []}
          loading={indoorRegisterationDataObj.loading}
          onRowClick={(row) => {
            const { patient, consultant_detail, ...others } = row;
            setSelectedRecord({
              ...others,
              consultant_detail: {
                ...consultant_detail,
                room: consultant_detail?.room?._id,
                nursing_station: consultant_detail?.room?.nurse_station,
                ward: consultant_detail?.room?.ward,
                department_unit: consultant_detail?.room?.department_unit
              }
            });
            setOpenQueryDialog(false);
          }}
        />
      </Dialog>
      <Dialog
        PaperProps={{ sx: { width: '80%', p: 2 } }}
        open={searchPatientRegisterationDialog}
        onClose={() => setSearchPatientRegisterationDialog(false)}
        maxWidth="xl"
        scroll="body"
      >
        <Stack
          padding={0}
          direction="row"
          spacing={2}
          alignItems="center"
          justifyContent="space-between"
          borderBottom="1px solid"
          borderColor="grey.300"
        >
          <Typography variant="h4" fontWeight="bold">
            Patient Query Window
          </Typography>
          <IconButton onClick={() => setSearchPatientRegisterationDialog(false)}>
            <CloseIcon color="error" fontSize="large" />
          </IconButton>
        </Stack>
        <Stack direction="row" spacing={2} alignItems="center" justifyContent="center" sx={{ mt: 0.5 }}>
          <MuiTextField
            sx={{
              width: '100%',
              '& .MuiOutlinedInput-root': {
                padding: '0',
                fontSize: '1.4rem' // Adjust input font size
              },
              '& .MuiOutlinedInput-input': {
                padding: '8px 1.4rem'
              },
              '& .MuiInputLabel-root': {
                fontSize: '1.2rem' // Adjust label font size
              }
            }}
            label="Search Patient"
            variant="outlined"
            value={input}
            onChange={handlePatientChange}
          />
        </Stack>
        <Table
          sx={{ mt: 0.5 }}
          columns={PATIENT_TABLE_HEADER}
          data={patientDataList || []}
          onRowClick={handlePatientRowClick}
          loading={patientDetailList.loading}
        />
      </Dialog>
    </>
  );
};
